import React, { useMemo, useEffect } from "react";
import useRouteUtils from "../../utils/hooks/useRouteUtils";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom"; // or usePathname in Next.js

const useMenus = () => {
  const { checkIfActiveRoute } = useRouteUtils();
  const globalState = useSelector((state) => state.global);
  const location = useLocation(); // gives current pathname

  const handleSetSlug = (slug) => {
    if (slug) {
      sessionStorage?.setItem("slug", slug);
    }
  };

  // central slug mapping (path → slug)
  const slugMappings = {
    "/orders/qc": "qc",
    "/orders/qc-recheck": "qc",
    "/orders/metal-qc": "metal_qc",
    "/orders/metal-qc-recheck": "metal_qc",
    "/orders/old-gold-qc": "og_qc",
    "/orders/old-gold-qc-recheck": "og_qc",
    "/orders/final-qc": "final_qc",
    "/orders/final-qc-recheck": "final_qc",
    "/orders/drum-ball": "drumball",
    "/orders/drum-ball-recheck": "drumball",
    "/orders/cvd": "cvd_rft",
    "/orders/cvd-recheck": "cvd_rft",
    "/orders/engraving": "engraving",
    "/orders/engraving-recheck": "engraving",
    "/orders/photo/photo-section": "photo_section",
    "/orders/photo/design-bank": "photo_section",
    "/orders/photo/photo-section-recheck": "photo_section",
    "/orders/photo/photo-section-reissue": "photo_section",
    "/orders/photo/old-card-reissue": "photo_section",
    "/orders/printing/printing-work": "printing",
    "/orders/printing-recheck/printing-work-recheck": "printing",
    "/orders/printing-reissue/printing-work-reissue": "printing",
    "/orders/printing-reissue/old-card-reissue": "printing",
    "/orders/packing": "packing",
    "/orders/packing-recheck": "packing",
    "/orders/delivery/delivery-work": "delivery",
    "/orders/delivery-recheck/delivery-work-recheck": "delivery",
    "/orders/delivery-reissue/delivery-work-reissue": "delivery",
    "/orders/delivery-reissue/old-card-reissue": "delivery",
    "/orders/delivery-completed/delivery-work-completed": "delivery",
    "/orders/delivery/delivery-challan": "delivery",
    "/verification/orders": "verification",
    "/verification/recheck": "verification",
    "/verification/reissue": "verification",
    "/verification/old-card-reissue": "verification",
    "/certificate-update": "certificate_update",
  };

  // Auto-update slug based on URL path
  useEffect(() => {
    const currentPath = location.pathname;
    const matchedSlug = Object.entries(slugMappings).find(([path]) =>
      currentPath.startsWith(path),
    );
    if (matchedSlug) {
      handleSetSlug(matchedSlug[1]);
    }
  }, [location.pathname]);
  const drawerMenu = [
    {
      title: "Employee Dashboard",
      label: "Employee Dashboard",
      link: "/master/dashboard",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">bar_chart_4_bars</span>,
      active:
        checkIfActiveRoute("/dashboard", true) ||
        checkIfActiveRoute("/master/dashboard", true),
    },
    {
      title: "Work Dashboard",
      label: "Work Dashboard",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">bar_chart_4_bars</span>,
      active: checkIfActiveRoute("/overview"),
      subMenu: [
        {
          title: "Orders",
          link: "/overview",
          active: checkIfActiveRoute("/overview", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Recheck",
          link: "/overview/recheck",
          active: checkIfActiveRoute("/overview/recheck", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
      ],
    },
    {
      title: "Stock Receipt",
      label: "Stock Receipt",
      link: "/orders",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">inventory</span>,
      active:
        checkIfActiveRoute("/orders", true) ||
        checkIfActiveRoute("/orders/recheck", true) ||
        checkIfActiveRoute("/orders/reassign", true),
      subMenu: [
        {
          title: "Orders",
          link: "/orders",
          active: checkIfActiveRoute("/orders", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Recheck",
          link: "/orders/recheck?activeTab=certificate",
          active: checkIfActiveRoute("/orders/recheck", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Reassign",
          link: "/orders/reassign?activeTab=orders",
          active: checkIfActiveRoute("/orders/reassign", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug(""),
        },
      ],
    },
    {
      title: "Verification",
      label: "Verification",
      link: "/verification/orders",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">new_releases</span>,
      active:
        checkIfActiveRoute("/verification", false) || // exact match unnecessary
        checkIfActiveRoute("/verification/orders", true) ||
        checkIfActiveRoute("/verification/recheck", true) ||
        checkIfActiveRoute("/verification/reissue", true),
      subMenu: [
        {
          title: "Orders",
          link: "/verification/orders",
          active: checkIfActiveRoute("/verification/orders", true),
          handleClick: () => handleSetSlug("verification"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Recheck",
          link: "/verification/recheck",
          active: checkIfActiveRoute("/verification/recheck", true),
          handleClick: () => handleSetSlug("verification"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Reissue",
          link: "/verification/reissue",
          active: checkIfActiveRoute("/verification/reissue", true),
          handleClick: () => handleSetSlug("verification"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Old Card Reissue",
          link: "/verification/old-card-reissue",
          active: checkIfActiveRoute("/verification/old-card-reissue", true),
          handleClick: () => handleSetSlug("verification"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
      ],
    },
    {
      title: "QC",
      label: "QC",
      link: "/qc",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">inventory</span>,
      active: checkIfActiveRoute("/orders/qc"),
      // handleClick: () => handleSetSlug("qc"),
      subMenu: [
        {
          title: "Orders",
          link: "/orders/qc",
          active: checkIfActiveRoute("/orders/qc", true),
          handleClick: () => handleSetSlug("qc"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Recheck",
          link: "/orders/qc-recheck",
          active: checkIfActiveRoute("/orders/qc-recheck"),
          handleClick: () => handleSetSlug("qc"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
      ],
    },
    {
      title: "Metal QC",
      label: "Metal QC",
      link: "/orders",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">done_all</span>,
      active: checkIfActiveRoute("/orders/metal-qc"),
      // handleClick: () => handleSetSlug("metal_qc"),
      subMenu: [
        {
          title: "Orders",
          link: "/orders/metal-qc",
          active: checkIfActiveRoute("/orders/metal-qc", true),
          handleClick: () => handleSetSlug("metal_qc"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Recheck",
          link: "/orders/metal-qc-recheck",
          active: checkIfActiveRoute("/orders/metal-qc-recheck"),
          handleClick: () => handleSetSlug("metal_qc"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
      ],
    },
    {
      title: "Old Gold QC",
      label: "Old Gold QC",
      link: "/qc",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">check_circle</span>,
      active: checkIfActiveRoute(
        "/orders/old-gold-qc" || "/orders/old-gold-qc-recheck",
      ),
      // handleClick: () => handleSetSlug("og_qc"),
      subMenu: [
        {
          title: "Orders",
          link: "/orders/old-gold-qc",
          active: checkIfActiveRoute("/orders/old-gold-qc", true),
          handleClick: () => handleSetSlug("og_qc"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Recheck",
          link: "/orders/old-gold-qc-recheck",
          active: checkIfActiveRoute("/orders/old-gold-qc-recheck"),
          handleClick: () => handleSetSlug("og_qc"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
      ],
    },
    {
      title: "Final QC",
      label: "Final QC",
      link: "/qc",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">fact_check</span>,
      active: checkIfActiveRoute("/orders/final-qc"),
      // handleClick: () => handleSetSlug("final_qc"),
      subMenu: [
        {
          title: "Orders",
          link: "/orders/final-qc",
          active: checkIfActiveRoute("/orders/final-qc", true),
          handleClick: () => handleSetSlug("final_qc"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Recheck",
          link: "/orders/final-qc-recheck",
          active: checkIfActiveRoute("/orders/final-qc-recheck"),
          handleClick: () => handleSetSlug("final_qc"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
      ],
    },
    {
      title: "Drumball",
      label: "Drumball",
      link: "/drum-ball",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">inventory</span>,
      active: checkIfActiveRoute("/orders/drum-ball"),
      // handleClick: () => handleSetSlug("drumball"),
      subMenu: [
        {
          title: "Orders",
          link: "/orders/drum-ball",
          active: checkIfActiveRoute("/orders/drum-ball", true),
          handleClick: () => handleSetSlug("drumball"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Recheck",
          link: "/orders/drum-ball-recheck",
          active: checkIfActiveRoute("/orders/drum-ball-recheck"),
          handleClick: () => handleSetSlug("drumball"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
      ],
    },
    {
      title: "CVD/RFT",
      label: "CVD/RFT",
      link: "/cvd",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">verified_user</span>,
      active: checkIfActiveRoute("/cvd"),
      // handleClick: () => handleSetSlug("cvd_rft"),
      subMenu: [
        {
          title: "Orders",
          link: "/orders/cvd",
          active: checkIfActiveRoute("/orders/cvd", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("cvd_rft"),
        },
        {
          title: "Recheck",
          link: "/orders/cvd-recheck",
          active: checkIfActiveRoute("/orders/cvd-recheck", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("cvd_rft"),
        },
      ],
    },
    {
      title: "Engraving",
      label: "Engraving",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">stylus_note</span>,
      active: checkIfActiveRoute("/engraving"),
      // handleClick: () => handleSetSlug("engraving"),
      subMenu: [
        {
          title: "Orders",
          link: "/orders/engraving",
          active: checkIfActiveRoute("/orders/engraving", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("engraving"),
        },
        {
          title: "Recheck",
          link: "/orders/engraving-recheck",
          active: checkIfActiveRoute("/orders/engraving-recheck", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("engraving"),
        },
      ],
    },
    // {
    //   title: "Photo Upload",
    //   label: "Photo Upload",
    //   iconAsset: "DrawerIcon1",
    //   icon: (
    //     <span className="material-symbols-outlined">photo_camera_back</span>
    //   ),
    //   active: checkIfActiveRoute("/photo-upload"),
    //   // handleClick: () => handleSetSlug("photo_section"),
    //   subMenu: [
    //     {
    //       title: "Orders",
    //       link: "/orders/photo-upload",
    //       active: checkIfActiveRoute("/orders/photo-upload", true),
    //       icon: <span className={`sub-icon`}>SR</span>,
    //       handleClick: () => handleSetSlug("photo_section"),
    //     },
    //     {
    //       title: "Recheck",
    //       link: "/orders/photo-upload-recheck",
    //       active: checkIfActiveRoute("/orders/photo-upload-recheck", true),
    //       icon: <span className={`sub-icon`}>SR</span>,
    //       handleClick: () => handleSetSlug("photo_section"),
    //     },
    //   ],
    // },
    {
      title: "Photo Upload",
      label: "Photo Upload",
      iconAsset: "DrawerIcon1",
      icon: (
        <span className="material-symbols-outlined">photo_camera_back</span>
      ),
      active:
        checkIfActiveRoute("/photo-section") ||
        checkIfActiveRoute("/orders/photo/design-bank", true),
      subMenu: [
        {
          title: "Orders",
          link: "/orders/photo/photo-section",
          active: checkIfActiveRoute("/orders/photo-section", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("photo_section"),
        },
        {
          title: "Recheck",
          link: "/orders/photo/photo-section-recheck",
          active: checkIfActiveRoute(
            "/orders/photo/photo-section-recheck",
            true,
          ),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("photo_section"),
        },
        {
          title: "Reissue",
          link: "/orders/photo/photo-section-reissue",
          active: checkIfActiveRoute(
            "/orders/photo/photo-section-reissue",
            true,
          ),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("photo_section"),
        },
        {
          title: "Old Card Reissue",
          link: "/orders/photo/old-card-reissue",
          active: checkIfActiveRoute("/orders/photo/old-card-reissue", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("photo_section"),
        },
        {
          title: "Design Bank",
          link: "/orders/photo/design-bank",
          active: checkIfActiveRoute("/orders/photo/design-bank", true),
          handleClick: () => handleSetSlug("photo_section"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
      ],
    },
    {
      title: "Printing",
      label: "Printing",
      link: "/printing",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">print</span>,
      active: checkIfActiveRoute("/printing"),
      // handleClick: () => handleSetSlug("printing"),
      subMenu: [
        {
          title: "Orders",
          link: "/orders/printing/printing-work",
          active: checkIfActiveRoute("/orders/printing/printing-work", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("printing"),
        },
        {
          title: "Recheck",
          link: "/orders/printing-recheck/printing-work-recheck",
          active: checkIfActiveRoute("/orders/printing-recheck"),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("printing"),
        },
        {
          title: "Reissue",
          link: "/orders/printing-reissue/printing-work-reissue",
          active: checkIfActiveRoute(
            "/orders/printing-reissue/printing-work-reissue",
            true,
          ),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("printing"),
        },
        {
          title: "Old Card Reissue",
          link: "/orders/printing-reissue/old-card-reissue",
          active: checkIfActiveRoute(
            "/orders/printing-reissue/old-card-reissue",
            true,
          ),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("printing"),
        },
      ],
    },
    {
      title: "Packing/Final QC",
      label: "Packing/Final QC",
      link: "/packing",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">archive</span>,
      active: checkIfActiveRoute("/packing"),
      // handleClick: () => handleSetSlug("packing"),
      subMenu: [
        {
          title: "Orders",
          link: "/orders/packing",
          active: checkIfActiveRoute("/orders/packing", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("packing"),
        },
        {
          title: "Recheck",
          link: "/orders/packing-recheck",
          active: checkIfActiveRoute("/orders/packing-recheck"),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("packing"),
        },
      ],
    },
    {
      title: "Billing",
      label: "Billing",
      link: "/billing",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">receipt_long</span>,
      active: checkIfActiveRoute("/billing"),
      subMenu: [
        {
          title: "Orders",
          link: "/billing",
          active: checkIfActiveRoute("/billing", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Recheck",
          link: "/billing/billing-recheck",
          active: checkIfActiveRoute("/billing/billing-recheck", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Reissue",
          link: "/billing/reissue",
          active: checkIfActiveRoute("/billing/reissue", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Old Card Reissue",
          link: "/billing/old-card-reissue",
          active: checkIfActiveRoute("/billing/old-card-reissue", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Estimate",
          link: "/billing/bill-estimate?activeTab=pending",
          active: checkIfActiveRoute("/billing/bill-estimate", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Invoice History",
          link: "/billing/invoice-history",
          active: checkIfActiveRoute("/billing/invoice-history", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
      ],
    },
    {
      title: "Report",
      label: "Report",
      link: "",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">summarize</span>,
      active: checkIfActiveRoute("/report"),
      subMenu: [
        {
          title: "DWSR",
          link: "/report/dwsr?activeTab=summary",
          active: checkIfActiveRoute("/report/dwsr", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => {},
        },
        {
          title: "Percentage Report",
          link: "/report/percentage",
          active: checkIfActiveRoute("/report/percentage", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => {},
        },
        {
          title: "External Reports",
          link: "/report",
          active: checkIfActiveRoute("/report", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => {},
        },
        {
          title: "Other Reports",
          link: "/report/other?activeTab=Branch",
          active: checkIfActiveRoute("/report/other"),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => {},
        },
        {
          title: "Gli Report",
          link: "/report/gli",
          active: checkIfActiveRoute("/report/gli"),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => {},
        },
      ],
    },
    {
      title: "View Report",
      label: "View Report",
      link: "/view-report",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">summarize</span>,
      active: checkIfActiveRoute("/report"),
    },
    {
      title: "Delivery",
      label: "Delivery",
      link: "/delivery",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">local_shipping</span>,
      active: checkIfActiveRoute("/delivery"),
      // handleClick: () => handleSetSlug("delivery"),
      subMenu: [
        {
          title: "Orders",
          link: "/orders/delivery/delivery-work",
          active: checkIfActiveRoute("/orders/delivery/delivery-work", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("delivery"),
        },
        {
          title: "Recheck",
          link: "/orders/delivery-recheck/delivery-work-recheck",
          active: checkIfActiveRoute(
            "/orders/delivery-recheck/delivery-work-recheck",
            true,
          ),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("delivery"),
        },
        {
          title: "Reissue",
          link: "/orders/delivery-reissue/delivery-work-reissue",
          active: checkIfActiveRoute(
            "/orders/delivery-reissue/delivery-work-reissue",
            true,
          ),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("delivery"),
        },
        {
          title: "Old Card Reissue",
          link: "/orders/delivery-reissue/old-card-reissue",
          active: checkIfActiveRoute(
            "/orders/delivery-reissue/old-card-reissue",
            true,
          ),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("delivery"),
        },
        {
          title: "Completed",
          link: "/orders/delivery-completed/delivery-work-completed?activeTab=orders",
          active: checkIfActiveRoute(
            "/orders/delivery-completed/delivery-work-completed",
            true,
          ),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("delivery"),
        },
        {
          title: "Delivery Challan",
          link: "/orders/delivery/delivery-challan?activeTab=delivery-challan",
          active: checkIfActiveRoute("/orders/delivery/delivery-challan", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("delivery"),
        },
        {
          title: "Cash Receipt",
          link: "/orders/delivery/invoices?activeTab=pending",
          active: checkIfActiveRoute("/orders/delivery/invoices", true),
          icon: <span className={`sub-icon`}>SR</span>,
          handleClick: () => handleSetSlug("delivery"),
        },
      ],
    },

    // {
    //   title: "Payment History",
    //   label: "Payment History",
    //   link: "/payment-history",
    //   iconAsset: "DrawerIcon1",
    //   icon: <span className="material-symbols-outlined">currency_rupee</span>,
    //   active: checkIfActiveRoute("/payment-history"),
    // },
    {
      title: "Masters",
      label: "Masters",
      iconAsset: "DrawerIcon1",
      icon: (
        <span className="material-symbols-outlined">admin_panel_settings</span>
      ),
      active: checkIfActiveRoute("/master"),
      subMenu: [
        {
          title: "Branches",
          link: "/master/branches",
          active: checkIfActiveRoute("/master/branches"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Source",
          link: "/master/source",
          active: checkIfActiveRoute("/master/source"),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Grading Type",
          link: "/master/item-grading",
          active: checkIfActiveRoute("/master/item-grading", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Item",
          link: "/master/item",
          active: checkIfActiveRoute("/master/item", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Packing Type",
          link: "/master/packing",
          active: checkIfActiveRoute("/master/packing", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Process",
          link: "/master/process",
          active: checkIfActiveRoute("/master/process", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Services",
          link: "/master/service",
          active: checkIfActiveRoute("/master/service", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Item Types",
          link: "/master/item-type",
          active: checkIfActiveRoute("/master/item-type", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Departments",
          link: "/master/department",
          active: checkIfActiveRoute("/master/department", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Role",
          link: "/master/role",
          active: checkIfActiveRoute("/master/role", false),
          // active: checkIfActiveRoute("/master/role/update", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Employee",
          link: "/master/employee",
          active: checkIfActiveRoute("/master/employee", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Supplier/Shop",
          link: "/master/shop",
          active: checkIfActiveRoute("/master/shop", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Certificate Prefix",
          link: "/master/certificate-prefix",
          active: checkIfActiveRoute("/master/certificate-prefix", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Lot Prefix",
          link: "/master/lot-prefix",
          active: checkIfActiveRoute("/master/lot-prefix", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Invoice Number Format",
          link: "/master/invoice-number-format",
          active: checkIfActiveRoute("/master/invoice-number-format", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Engraving Types",
          link: "/master/engraving",
          active: checkIfActiveRoute("/master/engraving", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Report/Certificate",
          link: "/master/report",
          active: checkIfActiveRoute("/master/report", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
        {
          title: "Billing",
          link: "/master/billing",
          active: checkIfActiveRoute("/master/billing", true),
          icon: <span className={`sub-icon`}>SR</span>,
        },
      ],
    },
    {
      title: "Bill To",
      label: "Bill To",
      link: "/bill-to-mapping",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">receipt</span>,
      active: checkIfActiveRoute("/bill-to-mapping"),
    },
    {
      title: "Activity Logs",
      label: "Activity Logs",
      link: "/activity-log",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">description</span>,
      active: checkIfActiveRoute("/activity-log"),
      handleClick: () => handleSetSlug(""),
    },
    {
      title: "Certificate Update",
      label: "Certificate Update",
      link: "/certificate-update",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">update</span>,
      active: checkIfActiveRoute("/certificate-update"),
    },
    {
      title: "Shop Certificate",
      label: "Shop Certificate",
      link: "/shop-certificate",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">image</span>,
      active: checkIfActiveRoute("/shop-certificate"),
    },
    {
      title: "Old Certificates",
      label: "Old Certificates",
      link: "/certificate-upload",
      iconAsset: "DrawerIcon1",
      icon: <span className="material-symbols-outlined">upload_file</span>,
      active: checkIfActiveRoute("/certificate-upload"),
    },
  ];
  const filteredMenus = useMemo(() => {
    const allowedMenus =
      globalState.dashboard_permissions?.menu_permissions || [];

    if (!Array.isArray(drawerMenu)) {
      return [];
    }
    const filteredDrawerMenu = drawerMenu?.map((menu) => {
      const matchingBackendMenu = allowedMenus.find(
        (backendMenu) => backendMenu?.menu_name === menu.title,
      );

      if (matchingBackendMenu) {
        const subMenuPermissions =
          matchingBackendMenu.sub_menu_permissions?.map(
            (subMenu) => subMenu?.sub_menu_name,
          ) || [];

        if (menu.subMenu && Array.isArray(menu?.subMenu)) {
          const filteredSubMenu = menu?.subMenu?.filter((subMenu) =>
            subMenuPermissions.includes(subMenu?.title),
          );

          return {
            ...menu,
            subMenu: filteredSubMenu,
          };
        } else {
          return {
            ...menu,
          };
        }
      }

      return null;
    });

    return filteredDrawerMenu.filter((menu) => menu !== null);
  }, [globalState?.dashboard_permissions, drawerMenu]);

  return { drawerMenu: filteredMenus };
};

export default useMenus;
